import axiosInstance from "../../../utils/axios";
import { tokenConfig } from "./auth";
import { socket } from "../../../config/socket";
import {
  AGENT_CREATE_SUCCESS,
  GET_ERRORS,
  REDIRECT,
  AGENT_CREATE_FAIL,
  LOAN_STATUS_CHANGE_SUCCESS,
  LOAN_STATUS_CHANGE_FAIL,
  GET_AGENTS,
  SETTLEMENT_SUCCESS,
  GET_AGENT,
  FILTER_AGENTS_BY_LOAN_STATUS,
  TIMELINE_SUCCESS,
} from "../actions/types";

export const createAgent =
  ({ inputData }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: inputData,
    });

    axiosInstance
      .post("agents?populate=*", data, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: AGENT_CREATE_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: AGENT_CREATE_FAIL,
        });
        dispatch({
          type: GET_ERRORS,
          payload: err.response,
        });
      });
  };

export const changeLoanStatus =
  ({ id, newStatus, reason, prevStatus }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: { loanStatus: newStatus },
    });

    axiosInstance
      .put(`agents/${id}?populate=*`, data, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: LOAN_STATUS_CHANGE_SUCCESS,
          payload: res.data.data,
        });
      })
      .then(() => {
        socket.emit(
          "addProduct",
          {
            agentId: id,
            reason: reason,
            prevStatus: prevStatus,
            newStatus: newStatus,
          },
          tokenConfig(getState)
        );
      })
      .catch((err) => {
        dispatch({
          type: LOAN_STATUS_CHANGE_FAIL,
        });
        dispatch({
          type: GET_ERRORS,
          payload: err.response,
        });
      });
  };
export const addSettlement =
  ({ id, settledAmount, checkProvided, checkRef, date, loan }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: {
        settledAmount: settledAmount,
        settlementDate: date,
        agent: id,
        checkProvided: checkProvided,
        checkRef: checkRef,
      },
    });

    axiosInstance.post("settlements", data, tokenConfig(getState)).then(() => {
      axiosInstance
        .put(
          `agents/${id}?populate=*`,
          {
            data: {
              loan: loan - settledAmount,
            },
          },
          tokenConfig(getState)
        )
        .then((res) => {
          dispatch({
            type: SETTLEMENT_SUCCESS,
            payload: res.data.data,
          });
        })
        .catch((err) => {
          console.log("ERROR", err);
          dispatch({
            type: GET_ERRORS,
            payload: err.response,
          });
        });
    });
  };
export const addLoan =
  ({ id, loanAmount, checkProvided, loan, checkRef, loanDate }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: {
        loanAmount: loanAmount,
        checkProvided: checkProvided,
        agent: id,
        checkRef: checkRef,
        loanDate: loanDate,
      },
    });

    axiosInstance.post("loans", data, tokenConfig(getState)).then(() => {
      axiosInstance
        .put(
          `agents/${id}?populate=*`,
          {
            data: {
              loan: parseInt(loan) + parseInt(loanAmount),
            },
          },
          tokenConfig(getState)
        )
        .then((res) => {
          dispatch({
            type: SETTLEMENT_SUCCESS,
            payload: res.data.data,
          });
        })
        .catch((err) => {
          console.log("ERROR", err);
          dispatch({
            type: GET_ERRORS,
            payload: err.response,
          });
        });
    });
  };

export const timelineMessage =
  ({ id, amount, message, type }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: {
        agent: id,
        amount: amount,
        type: type,
        message: message,
      },
    });

    axiosInstance
      .post("timelines", data, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: TIMELINE_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((err) => {
        console.log("ERROR", err);
        dispatch({
          type: GET_ERRORS,
          payload: err.response,
        });
      });
  };

export const getAgent =
  ({ id }) =>
  (dispatch, getState) => {
    axiosInstance
      .get(`agents/${id}?populate=*`, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: GET_AGENT,
          payload: res.data.data,
        });

        console.log("DISPATCH WUST", res);
      })
      .catch((err) => {
        dispatch({
          type: GET_ERRORS,
          payload: err.response,
        });
      });
  };

export const getAgents = () => (dispatch, getState) => {
  axiosInstance
    .get("agents?populate=*", tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_AGENTS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response,
      });
    });
};

export const filterAgents =
  ({ agents, loanStatusFilter }) =>
  (dispatch, getState) => {
    dispatch({
      type: FILTER_AGENTS_BY_LOAN_STATUS,
      payload: {
        loanStatusFilter: loanStatusFilter,
        filterdAgents:
          loanStatusFilter === ""
            ? agents
            : agents.filter(
                (agent) => agent.attributes.loanStatus === loanStatusFilter
              ),
      },
    });
  };

export const updateAgentDetail =
  ({ id, nameInput }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: {
        detail: nameInput,
      },
    });

    axiosInstance
      .put(`agents/${id}`, data, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: SETTLEMENT_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((err) => {
        console.log("ERROR", err);
        dispatch({
          type: GET_ERRORS,
          payload: err.response,
        });
      });
  };

export const redirect = () => (dispatch) => {
  dispatch({
    type: REDIRECT,
    payload: null,
  });
};
